import { render, staticRenderFns } from "./watchList.vue?vue&type=template&id=c3adb09c&scoped=true&"
import script from "./watchList.vue?vue&type=script&lang=js&"
export * from "./watchList.vue?vue&type=script&lang=js&"
import style0 from "./watchList.vue?vue&type=style&index=0&id=c3adb09c&lang=scss&scoped=true&"
import style1 from "./watchList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3adb09c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\maixun_cxx\\private_library\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3adb09c')) {
      api.createRecord('c3adb09c', component.options)
    } else {
      api.reload('c3adb09c', component.options)
    }
    module.hot.accept("./watchList.vue?vue&type=template&id=c3adb09c&scoped=true&", function () {
      api.rerender('c3adb09c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/watchList.vue"
export default component.exports